import { createRoot } from 'react-dom/client';
import LogRocket from 'logrocket';

import App from './App';

// Only initialize LogRocket in production or when explicitly enabled
if (process.env.REACT_APP_DISABLE_LOGROCKET !== 'true') {
    LogRocket.init('hilrjg/ontoworks-app');
}

const container = document.getElementById('root');

if (container) {
    const root = createRoot(container);
    root.render(<App />);
}
